export const floatingActions = {
	massEdit: "Edición masiva de productos",
	editExcel: "Importar vía Excel",
	testFiscal: "Probar integración fiscal",
	testFiscalData: "Probar datos fiscales",
	syncWithDelivery: "Sincronizar con delivery",
	deleteSelected: "Eliminar productos seleccionados",
};
